var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wifi on"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 6.00262C8.34783 6.00262 4.82108 7.33511 2.08131 9.75014C1.667 10.1153 1.03509 10.0755 0.669891 9.66122C0.304692 9.24692 0.344501 8.61501 0.758806 8.24981C3.86388 5.51277 7.86087 4.00262 12.0001 4.00262C16.1392 4.00262 20.1362 5.51277 23.2413 8.24981C23.6556 8.61501 23.6954 9.24692 23.3302 9.66122C22.965 10.0755 22.3331 10.1153 21.9188 9.75014C19.179 7.33511 15.6523 6.00262 12.0001 6.00262ZM12.0401 11.0021C9.70152 11.0021 7.43693 11.8217 5.64006 13.3184C5.2157 13.6719 4.58514 13.6144 4.23168 13.19C3.87822 12.7657 3.9357 12.1351 4.36006 11.7816C6.51631 9.98564 9.23381 9.00214 12.0401 9.00214C14.8463 9.00214 17.5638 9.98564 19.7201 11.7816C20.1444 12.1351 20.2019 12.7657 19.8484 13.19C19.495 13.6144 18.8644 13.6719 18.4401 13.3184C16.6432 11.8217 14.3786 11.0021 12.0401 11.0021ZM12.0051 16.0013C10.9673 16.0013 9.95522 16.3242 9.10922 16.9252C8.659 17.2451 8.03471 17.1394 7.71485 16.6892C7.39498 16.239 7.50066 15.6147 7.95089 15.2948C9.13529 14.4534 10.5522 14.0013 12.0051 14.0013C13.4579 14.0013 14.8748 14.4534 16.0592 15.2948C16.5095 15.6147 16.6151 16.239 16.2953 16.6892C15.9754 17.1394 15.3511 17.2451 14.9009 16.9252C14.0549 16.3242 13.0428 16.0013 12.0051 16.0013ZM11.0001 20C11.0001 19.4477 11.4478 19 12.0001 19H12.0101C12.5623 19 13.0101 19.4477 13.0101 20C13.0101 20.5523 12.5623 21 12.0101 21H12.0001C11.4478 21 11.0001 20.5523 11.0001 20Z",
    fill: "#269924"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOn);
export default __webpack_public_path__ + "static/media/WifiOn.38d969d55fd8ea4579ca9d2264dee885.svg";
export { ForwardRef as ReactComponent };